import i18n from 'utils/i18n';

export const RETRY_OR_CONTACT_SUPPORT = i18n.t(
  'frontproductstream.constants.error.message',
  {
    defaultValue: 'An error occured, please retry or contact our support team',
  },
);
